import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNotification = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17,
	height: 19,
	viewBox: "0 0 17 19",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.18507 17.375C6.80206 17.9196 7.61253 18.25 8.50017 18.25C9.38781 18.25 10.1983 17.9196 10.8153 17.375M13.7502 6C13.7502 4.60761 13.197 3.27226 12.2125 2.28769C11.2279 1.30312 9.89256 0.75 8.50017 0.75C7.10778 0.75 5.77242 1.30312 4.78786 2.28769C3.80329 3.27226 3.25017 4.60761 3.25017 6C3.25017 8.70391 2.56808 10.5552 1.80613 11.7797C1.16341 12.8126 0.842045 13.3291 0.853828 13.4732C0.866876 13.6327 0.900672 13.6935 1.02922 13.7889C1.14532 13.875 1.66869 13.875 2.71542 13.875H14.2849C15.3317 13.875 15.855 13.875 15.9711 13.7889C16.0997 13.6935 16.1335 13.6327 16.1465 13.4732C16.1583 13.3291 15.8369 12.8126 15.1942 11.7797C14.4323 10.5552 13.7502 8.70391 13.7502 6Z",
		stroke: "currentColor",
		strokeWidth: 1.3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgNotification;
